module.exports = __webpack_public_path__ + "static/img/youyanji8c0a5a8.png";